import {
  SERVICE_MODE_META,
  DEFAULT_SERVICE_MODE,
  getServiceMode,
  getServiceModeLabel,
} from '@/constants/serviceModes';
import AppStatusChip from '../buttons/AppStatusChip';

/**
 * ServiceModeChip — pillola della modalità di servizio (icona + testo).
 *
 * Codifica il `service_mode` con icona SVG FontAwesome + label localizzata +
 * colore semantico (mai solo colore — accessibilità). Wrappa <AppStatusChip>.
 *
 * Passare `order` (usa getServiceMode con fallback a transport) oppure `mode`
 * esplicito. `fullCell` default false (uso inline/card); true per riempire una
 * cella DataGrid.
 */
export default function ServiceModeChip({ order, mode, fullCell = false, ...rest }) {
  const resolved = mode && SERVICE_MODE_META[mode] ? mode : getServiceMode(order);
  const meta = SERVICE_MODE_META[resolved] || SERVICE_MODE_META[DEFAULT_SERVICE_MODE];

  return (
    <AppStatusChip
      variant={meta.variant}
      icon={meta.icon}
      label={getServiceModeLabel(resolved)}
      fullCell={fullCell}
      {...rest}
    />
  );
}
